export const PERSONALIZATION_STATUS = {
  DEFAULT: 'DEFAULT',
  VARIANT: 'VARIANT'
};